import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Col, Form, Input, Label, Row, Table } from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import API from "../../../api"
import { withTranslation } from "react-i18next"
import { AvForm, AvField } from "availity-reactstrap-validation"
import DatePicker from "react-datepicker";
import getDay from "date-fns/getDay"
import Select from "react-select"
import Switch from "react-switch"
const AddSpecialiteOrientation = props => {

  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  const [niveau, setNiveau] = useState("")
  const [selectNiveau, setSelectNiveau] = useState("")
  const [specialite, setSpecialite] = useState([])
  const [selectSpecialite, setSelectSpecialite] = useState("")
  const [array, setArray] = useState([]);

  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  const save = async () => {
    const cleanedArray = array.map((s) => ({
      ...s,
      capacite: Number(s.capacite) || 0,
      etat: s.etat === 1 ? 1 : 0,
    }));
    try {
      const res = await API.post("specialite_orientation/add", {
        annee_id: annee_id,
        user_id: user_id,
        niveau_id: selectNiveau.value,
        specialite_source_id: selectSpecialite.value,
        array: cleanedArray,
      })
      toast.success("🔓✔️ Spécialité Mastère ajoutée avec succès", {
        containerId: "A",
      });
      props.setSection(1);
    } catch (error) {
      toast.error("⛔ Erreur lors de l'enregistrement des spécialités", {
        containerId: "A",
      });
    }
  };

  useEffect(async () => {
    const resNiveau = await API.get(
      "specialite_orientation/select_niveau"
    ).then(resNiveau => {
      setNiveau(resNiveau.data.Niveau)
    })
  }, [])
  const Offsymbol = () => {
    return (
      <div
        title="Désactivé"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        D
      </div>
    );
  };
  const OnSymbol = () => {
    return (
      <div
        title="Activé"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        A
      </div>
    );
  };
  const handleCapaciteChange = (index, value) => {
    setArray(prev =>
      prev.map((item, i) =>
        i === index ? { ...item, capacite: value } : item
      )
    )
  }
  const handleEtatChange = (index) => {
    setArray(prev =>
      prev.map((item, i) =>
        i === index
          ? { ...item, etat: item.etat === 1 ? 0 : 1 }
          : item
      )
    );
  };
  const getSpec = async event => {
    setSelectNiveau(event)
    setSelectSpecialite("")
    setArray([])
    const res = await API.post(
      "specialite_orientation/select_specialite_by_niveau",
      {
        niveau_id: event.value,
      }
    ).then(res => {
      setSpecialite(res.data.Specialites)
    })
  }
  const getSpecNew = async event => {
    setSelectSpecialite(event)
    setArray([])
    const res = await API.post(
      "specialite_orientation/get_all_specialites_config",
      {
        annee_id,
        niveau_id: selectNiveau.value,
        specialite_source_id: event.value,
      }
    ).then(res => {
      setArray(res.data.Specialites)
    })
  }
  const handleOrientationChange = index => {
    const updatedArray = [...array]

    updatedArray[index].orientation_defaut =
      updatedArray[index].orientation_defaut === 1 ? 0 : 1

    setArray(updatedArray)
  }
  return (
    <React.Fragment>
      <Row>
        <AvForm>
          <Form>
            <Row>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">
                    {props.t("Niveau")}
                  </Label>
                  <Select
                    options={niveau}
                    isSearchable={true}
                    onChange={e => getSpec(e)}
                  />
                </div>
              </Col>
              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">Spécialité</Label>
                  <Select
                    options={specialite}
                    isSearchable={true}
                    value={selectSpecialite}
                    onChange={e => getSpecNew(e)}
                  />
                </div>
              </Col>
            </Row>
            <Row>
              <Table className="mt-3" striped bordered hover>
                <thead>
                  <th style={{ textAlign: "center" }}></th>
                  <th style={{ textAlign: "center" }}>
                    Spécialité : diplôme - niveau
                  </th>
                  <th style={{ textAlign: "center" }}>Capacité</th>
                  <th style={{ textAlign: "center" }}>Etat</th>
                  <th style={{ textAlign: "center" }}>
                    Orientation par défaut
                  </th>
                </thead>
                <tbody>
                  {array.map((specialite, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>{index + 1}</td>
                      <td style={{ textAlign: "center" }}>
                        {specialite.specialite_name}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <Input
                          type="number"
                          className="form-control text-center"
                          placeholder="Capacité externe"
                          value={specialite.capacite}
                          onChange={e =>
                            handleCapaciteChange(index, e.target.value)
                          }
                        />
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <Switch
                          uncheckedIcon={<Offsymbol />} // Désactivé
                          checkedIcon={<OnSymbol />} // Activé
                          className="me-1 mb-sm-8 mb-2"
                          onColor="#34c38f"
                          checked={specialite.etat === 1} // 🔥 Correct
                          disabled={specialite.etat_matieres === 1} // 🔥 Correct
                          onChange={() => handleEtatChange(index)} // 🔥 Pour modifier l’état
                        />
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <Input
                          disabled={specialite.orientation_defaut === 1}
                          type="checkbox"
                          checked={specialite.orientation_defaut === 1}
                          onChange={() => handleOrientationChange(index)}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Row>
          </Form>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {" "}
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                className="text-center mt-4"
              >
                <Button
                  type="button"
                  color="warning"
                  className="btn btn-warning  mb-2 me-2"
                  onClick={props.back}
                >
                  {props.t("Annuler")}
                </Button>
              </div>
            </Col>
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
                className="text-center mt-4"
              >
                <button
                  type="button"
                  className="btn btn-primary "
                  onClick={save}
                >
                  {props.t("Confirmer")}
                </button>
              </div>
            </Col>
          </div>
        </AvForm>
      </Row>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withTranslation()(AddSpecialiteOrientation)
AddSpecialiteOrientation.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
